<bic-popup (close)="close()" [hasBackdrop]="true" customClass="h-[500px] w-[400px]"
  [title]="enterCode ? '2FA Deaktivieren' : changeMethode ? '2FA Anpassen' : '2FA Deaktivieren'">
  <div bicPopupContent class="flex flex-col items-start h-full">
    @if (!changeMethode && !enterCode) {
      <div class="flex flex-col">
        <span>Herabstufung der Kontosicherheit.<br><br></span>
        <span>Wenn Sie fortfahren, deaktivieren Sie die Zwei-Faktor-Authentifizierung für Ihr Konto. Um Ihr Konto bestmöglich zu schützen, empfehlen wir Ihnen, die 2FA aktiviert zu lassen. Falls Sie diese Schutzfunktion dennoch deaktivieren möchten, bestätigen Sie dies durch Auswahl von „Deaktivieren“.</span>
      </div>
    }

    @if(changeMethode && !enterCode) {
      <div class="flex flex-col">
        <span>Änderung der Kontosicherheit.<br><br></span>
        <span>Wenn Sie fortfahren, ändern Sie die Methode der Zwei-Faktor-Authentifizierung für Ihr Konto. Zuerst wird die bestehende Methode deaktiviert, anschließend die neue Methode aktiviert. Bitte bestätigen Sie die Änderung mit “Weiter”, falls Sie fortfahren möchten.</span>
      </div>
    }

    @if(enterCode) {
      <div class="flex flex-col"><span>Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.</span></div>
      <div class="flex-1 flex flex-col justify-center  w-full">
        <!--              <label for="code" class="block text-sm mb-1 font-medium text-white">2FA Code</label>-->
        <div [formGroup]="mfaForm" class="flex flex-row justify-between w-full" id="code">
          <input #otpInput (input)="moveToNext($event, 0)" (keydown)="moveToNext($event, 0)" (paste)="moveToNext($event, 0)"
                 [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                 class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                 formControlName="code1" maxlength="1" type="number">
          <input #otpInput (input)="moveToNext($event, 1)" (keydown)="moveToNext($event, 1)" (paste)="moveToNext($event, 1)"
                 [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                 class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                 formControlName="code2" maxlength="1" type="number">
          <input #otpInput (input)="moveToNext($event, 2)" (keydown)="moveToNext($event, 2)" (paste)="moveToNext($event, 2)"
                 [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                 class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                 formControlName="code3" maxlength="1" type="number">
          <input #otpInput (input)="moveToNext($event, 3)" (keydown)="moveToNext($event, 3)" (paste)="moveToNext($event, 3)"
                 [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                 class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                 formControlName="code4" maxlength="1" type="number">
          <input #otpInput (input)="moveToNext($event, 4)" (keydown)="moveToNext($event, 4)" (paste)="moveToNext($event, 4)"
                 [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                 class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                 formControlName="code5" maxlength="1" type="number">
          <input #otpInput (input)="moveToNext($event, 5)" (keydown)="moveToNext($event, 5)" (paste)="moveToNext($event, 5)"
                 [class]="mfaError ? 'text-red ring-red border-red' : 'focus:ring-white focus:border-white border-gray-300'"
                 class="text-center text-sm rounded-lg bg-gray-100 placeholder-gray-400 block w-10 p-2.5"
                 formControlName="code6" maxlength="1" type="number">
        </div>
        @if (mfaForm.get('code1')?.touched && mfaForm.get('code1')?.invalid) {
          @if (mfaForm.get('code1')?.errors?.required) {
            <span class="text-xs text-red pt-1">Sie müssen den 2FA Code eingeben.</span>
          }
          @if (mfaForm.get('code1')?.errors?.pattern) {
            <span class="text-xs text-red pt-1">Der Code muss 6 Ziffern lang sein.</span>
          }
        }
        @if (mfaError) {
          <span class="text-xs text-red pt-1">Der eingegebene Code ist nicht korrekt.</span>
        }
      </div>
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
    @if(!changeMethode && !enterCode) {
      <bic-button (onClick)="close()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="approve()" [loading]="isApproveLoading">Deaktivieren</bic-button>
    }

    @if(changeMethode && !enterCode) {
      <bic-button (onClick)="close()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="approve()" [loading]="isApproveLoading">Weiter</bic-button>
    }
    @if (enterCode) {
      <bic-button (onClick)="close()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="verify()" [loading]="isVerifyLoading">Deaktivieren</bic-button>
    }
  </div>
</bic-popup>
